import { curry2 } from '@most/prelude';
export var next = curry2(function next(value, subject) {
    return subject.next(value);
});
//# sourceMappingURL=next.js.map